import {Injectable} from '@angular/core';
import {AuthService} from '../auth.service';
import {Authority} from '../../models/authority';
import {parseJwtPayload} from '../../utils/jwt';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable()
export class AuthServiceMock implements AuthService {

    private authoritiesSubject = new BehaviorSubject<Authority[]>([]);
    authorities$: Observable<Authority[]> = this.authoritiesSubject.asObservable();

    async initialize(): Promise<void> {
        const accessToken = localStorage.getItem('accessToken');
        const idToken = parseJwtPayload(accessToken);

        const isEditor = idToken &&
            idToken.roles && Array.isArray(idToken.roles) && idToken.roles.some((it: any) => it === Authority.editor);
        this.authoritiesSubject.next(isEditor ? [Authority.editor] : []);
    }
}
